import React, { useContext } from 'react';
import FeedContext from '../context/FeedContext';

export function useFeedContext() {
  return useContext(FeedContext);
}

export default useFeedContext;
